export const LeadActions = {
  UPDATE_DATA: "[Lead] update data",
};

export const updateLeadAction = (data) => {
  return {
    type: LeadActions.UPDATE_DATA,
    payload: data,
  };
};